export function BillingSettings() {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-medium">Billing Settings</h3>
        <p className="text-sm text-muted-foreground">
          Manage your billing and subscription preferences
        </p>
      </div>
      <div className="rounded-lg border p-8 text-center">
        <p className="text-muted-foreground">Billing settings coming soon...</p>
      </div>
    </div>
  );
}